import { Breakpoints, BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { AppService } from 'src/app/app.service';
import { getDate } from 'src/app/helpers/date_format';
import { MessageUtil } from 'src/app/helpers/messages';
import { ViewCompanyRecordComponent } from '../modals/view-company-record/view-company-record.component';
import { ViewIndividualRecordComponent } from '../modals/view-individual-record/view-individual-record.component';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  loading: boolean;
  allLists: any = [];
  personalList: any = [];
  companyList: any = [];
  list: any = [];
  watchList: any = [];
  companywatchList: any = [];
  individualwatchList: any = [];

  
  roleList = this.app.helperService.getRoleList()
  permission: any;
  permission2: any;

  constructor(private app: AppService, private dialog: MatDialog) {}

  ngOnInit(): void {
    this.getAllRecord()
    this.getPermission()

  }
  
  getAllRecord() {
    this.loading = true;
    this.app.recordService.getRecordList(this.app.helperService.getClientId(),0,1000)
    .subscribe(res => {
      if (res['message'] == MessageUtil.RESPONSE_SUCCESS) {
        this.allLists = res['data']
        this.loading = false

        this.personalList = this.allLists.filter(el => {
          return  el.type == "PERSONAL"
        })

        this.companyList = this.allLists.filter(el => {
          return  el.type == "ORGANIZATION"
        })

        this.watchList = this.allLists.filter(el => {
          return  el.watchlist == "Yes"
        })

        this.companywatchList = this.allLists.filter(el => {
          return  el.watchlist == "Yes" && el.type == "ORGANIZATION"
        })

        this.individualwatchList = this.allLists.filter(el => {
          return  el.watchlist == "Yes" && el.type == "PERSONAL"
        })

        this.list = this.allLists.slice(0 ,5)
      }
      else { 
        this.loading = false
        this.allLists = [] 
      }
    }, err => {
      this.loading = false
    }
    )
  }

  viewData(row) {
    if (row.type == 'personal') {
      this.openIndividual(row)
    }
    else {
      this.openCompany(row)
    }
  }

  openIndividual(row) {
    let dialogConfig = new MatDialogConfig()
    dialogConfig.disableClose = true;
    dialogConfig.minWidth = "50%"
    dialogConfig.minHeight = "70vh"
    dialogConfig.maxHeight = "100vh"      
    dialogConfig.data = row  

    this.dialog.open(ViewIndividualRecordComponent, dialogConfig)
    .afterClosed().subscribe(result => {
      if (result == MessageUtil.SUCCESS) {

      }
    });
  }

  openCompany(row) {
    let dialogConfig = new MatDialogConfig()
    dialogConfig.disableClose = true;
    dialogConfig.minWidth = "50%"
    dialogConfig.minHeight = "70vh"
    dialogConfig.maxHeight = "100vh"  
    dialogConfig.data = row  

    this.dialog.open(ViewCompanyRecordComponent, dialogConfig)
    .afterClosed().subscribe(result => {
      if (result == MessageUtil.SUCCESS) {

      }
    });
  }



  getDateFormat(value) {
    return getDate(value)
  }

  getPermission(){
    this.permission = this.roleList.find(el => el.name == 'Dashboard')
    this.permission2 = this.roleList.find(el => el.name == 'Record')

    
  }
}
